<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-sm-12 d-flex justify-content-between mb-2">
        <div class="text-center d-flex">
          <a href="/wp-admin" type="button" class="btn btn-light"><i class="fal fa-arrow-left"></i> Atras</a>
          <h4 class="page-title ms-2 mb-0">
            {{ mode === 'create' ? 'Registrar' : 'Actualizar' }} Noticia {{ extra.ver_english ? '(Ingles)' : '' }}
          </h4>
        </div>
        <div>
          <button class="btn btn-light" @click="toPreview()">Vista previa</button>
          <button
            v-show="mode === 'create'"
            @click="store()"
            type="button"
            class="ms-2 btn btn-primary"
            :disabled="loading.update"
          >
            <i class="fal" :class="loading.update ? 'fa-circle-notch fa-spin' : 'fa-save'"></i>
            {{ form.status == 'public' ? 'Publicar' : 'Guardar' }}
          </button>
          <button
            v-show="mode === 'update'"
            @click="update()"
            type="button"
            class="ms-2 btn btn-primary"
            :disabled="loading.update"
          >
            <i class="fal" :class="loading.update ? 'fa-circle-notch fa-spin' : 'fa-save'"></i>
            {{ form.status == 'public' ? 'Publicar' : 'Guardar' }}
          </button>
        </div>
      </div>
      <div class="col-md-8">
        <div class="indeterminate-progress-bar mb-2" v-show="loading.update || loading.show">
          <div class="indeterminate-progress-bar__progress"></div>
        </div>
        <!-- <quill-editor ref="refQuillEditor" theme="snow" toolbar="full"></quill-editor> -->
        <div v-show="!extra.ver_english">
          <quill ref="refQuillEditor" theme="snow" toolbar="full"></quill>
        </div>
        <div v-show="extra.ver_english">
          <quill ref="refQuillEnglish" theme="snow" toolbar="full"></quill>
        </div>
      </div>
      <div class="col-md-4">
        <div class="alert alert-success py-2 px-3" v-if="successMessage">
          <i class="fal fa-check-circle me-1"></i> {{ successMessage }}
        </div>
        <ul>
          <li class="text-danger" v-for="(item, index) in errors" :key="index">{{ item[0] }}</li>
        </ul>
        <div class="alert alert-danger py-2 px-3" v-if="generalError">
          <i class="fal fa-exclamation-triangle me-1"></i> {{ generalError }}
        </div>
        <div class="card mb-2">
          <div class="card-body">
            <div class="form-group row">
              <label for="name" class="col-sm-3 col-form-label">Título</label>
              <div class="col-sm-9">
                <textarea
                  v-model="form.name"
                  class="form-control"
                  name="name"
                  id="name"
                  cols="50"
                  rows="2"
                ></textarea>
                <!-- <input v-model="form.name" type="text" class="form-control" id="name" name="name" placeholder="" /> -->
              </div>
            </div>

            <div class="form-check">
              <input v-model="extra.ver_english" class="form-check-input" type="checkbox" id="venglish" />
              <label class="form-check-label" for="venglish">Mostrar Versión Ingles </label>
            </div>

            <div class="form-group row" v-show="extra.ver_english">
              <label for="name_english" class="col-sm-3 col-form-label">Título (Ingles)</label>
              <div class="col-sm-9">
                <textarea
                  v-model="form.name_english"
                  class="form-control"
                  name="name_english"
                  id="name_english"
                  cols="50"
                  rows="2"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="card mb-2">
          <div class="card-body">
            <div class="row">
              <label for="image" class="col-sm-3 col-form-label">Imagen principal</label>
              <div class="col-sm-9">
                <div class="mb-2 text-center">
                  <img :src="form.image" alt="IMG" class="demo-image" v-show="form.image" />
                  <span class="text-muted" v-show="!form.image">Sin asignación</span>
                </div>
                <div class="d-flex justify-content-center">
                  <button class="btn btn-outline-light rounded-pill ms-2" @click="onPickFile">
                    <i class="fal" :class="loading.upload ? 'fa-circle-notch fa-spin' : 'fa-upload'"></i> Subir
                    Imagen
                  </button>
                </div>
              </div>
              <input
                type="file"
                style="display: none"
                ref="fileInputNews"
                accept="image/jpeg, image/png"
                @change="onFilePicked"
              />
            </div>
          </div>
        </div>

        <div class="card mb-2">
          <div class="card-body">
            <div class="row">
              <label for="pdf" class="col-sm-3 col-form-label">PDF adjunto</label>
              <div class="col-sm-9">
                <div class="mb-2 text-center">
                  <a v-show="form.pdf" :href="form.pdf" target="_blank">
                    <i class="fal fa-file-pdf"></i> Ver PDF actual
                  </a>
                  <span class="text-muted" v-show="!form.pdf">Sin asignación</span>
                </div>
                <div class="d-flex justify-content-center">
                  <button class="btn btn-outline-light rounded-pill ms-2" @click="onPickPdf">
                    <i class="fal" :class="loading.uploadPdf ? 'fa-circle-notch fa-spin' : 'fa-upload'"></i> Subir
                    PDF
                  </button>
                </div>
              </div>
              <input
                type="file"
                style="display: none"
                ref="fileInputPdf"
                accept="application/pdf"
                @change="onPdfPicked"
              />
            </div>
          </div>
        </div>

        <div class="card mb-2">
          <div class="card-body">
            <div class="row">
              <label for="">Estado y Visibilidad</label>
            </div>
            <div class="form-group row">
              <label for="image" class="col-sm-4 col-form-label">Visibilidad</label>
              <div class="col-md-8">
                <div class="form-group">
                  <select
                    v-model="form.status"
                    class="form-select form-control"
                    aria-label="Estado"
                  >
                    <option value="draft">Borrador</option>
                    <option value="wait">En revisión</option>
                    <option value="public">Público</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <a href="#">{{ new Date().toLocaleDateString('en-US') }}</a>
            </div>
          </div>
        </div>
        <div class="card mb-2">
          <div class="card-body">
            <div class="row">
              <label for="" style="font-size: 15px; font-weight: 700">SEO</label>
            </div>
            <div class="form-group">
              <div for="field1" class="l">Frase clave objetivo</div>
              <input
                v-model="form.seo_title"
                type="text"
                class="form-control"
                id="field1"
                name="field1"
                placeholder=""
              />
            </div>
            <div class="form-group">
              <div class="form-check">
                <input
                  v-model="extra.gen_slug"
                  class="form-check-input"
                  disabled
                  type="checkbox"
                  id="gridCheck1"
                />
                <label class="form-check-label" for="gridCheck1">Generar slug enlace </label>
              </div>
            </div>
            <!-- <div class="form-group">
              <div for="field2" class="l">Título del sitio</div>
              <input type="text" class="form-control" id="field2" name="field2" placeholder="" />
            </div> -->
            <div class="form-group">
              <div for="field3" class="l">Meta description</div>
              <textarea
                v-model="form.seo_description"
                class="form-control"
                name="field3"
                id="field3"
                cols="50"
                rows="3"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Quill from '../Quill.vue'
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf'

pdfjsLib.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.js'

export default {
  name: 'NewsEdit',
  components: {
    Quill,
  },
  props: {
    new_id: {
      type: String,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      mode: 'create',
      form: {
        name: null,
        name_english: null,
        contenido: null,
        contenido_english: null,
        status: 'draft',
        image: null,
        pdf: null,
        seo_title: null,
        seo_description: null,
      },
      extra: {
        gen_slug: true,
        ver_english: false,
      },
      data: {},
      errors: {},
      generalError: '',
      successMessage: null,
      successTimeout: null,
      loading: {
        show: false,
      },
      sw_preview: false,
      image: null,
      imageUrl: null,
    }
  },
  mounted() {
    if (this.new_id) {
      this.getData()
    }
  },
  methods: {
    toPreview() {
      if (this.mode == 'update') {
        return window.open(this.urlPreview)
      } else {
        this.sw_preview = true
        this.form.status = 'draft'
        this.store()
      }
    },
    onPickFile() {
      this.$refs.fileInputNews.click()
    },
    onPickPdf() {
      this.$refs.fileInputPdf.click()
    },
    onPdfPicked(event) {
      const files = event.target.files
      if (!files.length) return
      const file = files[0]
      const maxBytes = 20 * 1024 * 1024
      if (file.size > maxBytes) {
        alert('El archivo PDF supera el límite de 20MB. Por favor sube un archivo más liviano.')
        event.target.value = ''
        return
      }
      this.uploadPdf(file)
      this.generatePdfThumbnail(file)
    },
    uploadPdf(file) {
      const self = this
      const formData = new FormData()
      self.loading.uploadPdf = true
      formData.append('image', file)
      formData.append('type', 'news_pdf')
      axios
        .post('/admin/photoUpload', formData)
        .then((res) => {
          self.form.pdf = res.data.data.PathUrl
        })
        .catch((err) => {
          console.error('Error:', err)
          const msg =
            err.response?.data?.errors?.image?.[0] ||
            'No se pudo subir el PDF. Verifica que pese máximo 20MB y vuelve a intentar.'
          alert(msg)
        })
        .finally(() => {
          self.loading.uploadPdf = false
        })
    },
    generatePdfThumbnail(file) {
      const self = this
      const reader = new FileReader()
      reader.onload = function () {
        const typedarray = new Uint8Array(this.result)
        pdfjsLib
          .getDocument({ data: typedarray })
          .promise.then((pdf) => pdf.getPage(1))
          .then((page) => {
            const viewport = page.getViewport({ scale: 1.3 })
            const canvas = document.createElement('canvas')
            canvas.width = viewport.width
            canvas.height = viewport.height
            const ctx = canvas.getContext('2d')
            return page.render({ canvasContext: ctx, viewport }).promise.then(() => canvas)
          })
          .then((canvas) => {
            canvas.toBlob((blob) => {
              if (blob) self.uploadPdfThumbnail(blob)
            }, 'image/png')
          })
          .catch((err) => {
            console.error('No se pudo generar la vista previa del PDF:', err)
          })
      }
      reader.readAsArrayBuffer(file)
    },
    uploadPdfThumbnail(blob) {
      const self = this
      const formData = new FormData()
      formData.append('image', blob, 'pdf-preview.png')
      formData.append('type', 'news')
      axios
        .post('/admin/photoUpload', formData)
        .then((res) => {
          // Solo autocompleta la imagen principal si aún no hay una asignada
          if (!self.form.image) {
            self.form.image = res.data.data.PathUrl
          }
        })
        .catch((err) => {
          console.error('Error subiendo la vista previa del PDF:', err)
        })
    },
    onFilePicked(event) {
      const files = event.target.files
      let filename = files[0].name
      const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.imageUrl = fileReader.result
      })
      fileReader.readAsDataURL(files[0])
      this.image = files[0]
      this.uploadImage()
    },
    uploadImage() {
      const self = this
      const formData = new FormData()
      self.loading.upload = true
      formData.append('image', this.image)
      formData.append('type', 'news')
      axios
        .post('/admin/photoUpload', formData)
        .then((res) => {
          self.form.image = res.data.data.PathUrl
        })
        .catch((err) => {
          console.error('Error:', err)
          const msg =
            err.response?.data?.errors?.image?.[0] ||
            'No se pudo subir la imagen. Verifica el archivo e inténtalo de nuevo.'
          alert(msg)
        })
        .finally(() => {
          self.loading.upload = false
        })
    },
    setForm(noticia) {
      this.form.name = noticia.name
      this.form.name_english = noticia.name_english
      this.form.image = noticia.image
      this.form.pdf = noticia.pdf
      this.form.status = noticia.status
      this.form.seo_title = noticia.seo_title
      this.form.seo_description = noticia.seo_description
      this.$refs.refQuillEditor.$refs.quillIn.setHTML(noticia.contenido)
      this.$refs.refQuillEnglish.$refs.quillIn.setHTML(noticia.contenido_english)
      this.data = noticia
      this.mode = 'update'
    },
    getData() {
      const self = this
      self.loading.show = true
      axios
        .get('/admin/news/' + self.new_id)
        .then((res) => {
          if (res.data.success) {
            self.setForm(res.data.data)
          }
        })
        .finally(() => {
          self.loading.show = false
        })
    },
    store() {
      const self = this
      self.loading.update = true
      self.errors = {}
      self.generalError = ''
      axios
        .post('/admin/news', {
          name: self.form.name,
          name_english: self.form.name_english,
          image: self.form.image,
          pdf: self.form.pdf,
          status: self.form.status,
          seo_title: self.form.seo_title,
          seo_description: self.form.seo_description,
          contenido: self.$refs.refQuillEditor.$refs.quillIn.getHTML(),
          contenido_english: self.$refs.refQuillEnglish.$refs.quillIn.getHTML(),
        })
        .then((res) => {
          if (res.data.success) {
            self.setForm(res.data.data)
            self.errors = {}
            if (self.sw_preview) {
              window.open(self.urlPreview)
            } else {
              self.showSuccess()
            }
          }
        })
        .catch((e) => {
          self.handleSaveError(e)
        })
        .finally(() => {
          self.loading.update = false
        })
    },
    update() {
      const self = this
      self.loading.update = true
      self.errors = {}
      self.generalError = ''
      axios
        .put('/admin/news/' + self.data.id, {
          name: self.form.name,
          name_english: self.form.name_english,
          image: self.form.image,
          pdf: self.form.pdf,
          status: self.form.status,
          seo_title: self.form.seo_title,
          seo_description: self.form.seo_description,
          contenido: self.$refs.refQuillEditor.$refs.quillIn.getHTML(),
          contenido_english: self.$refs.refQuillEnglish.$refs.quillIn.getHTML(),
        })
        .then((res) => {
          if (res.data.success) {
            self.setForm(res.data.data)
            self.errors = {}
            self.showSuccess()
          }
        })
        .catch((e) => {
          self.handleSaveError(e)
        })
        .finally(() => {
          self.loading.update = false
        })
    },
    handleSaveError(e) {
      if (e.response && e.response.status === 422 && e.response.data && e.response.data.errors) {
        this.errors = e.response.data.errors
      } else if (e.response && e.response.status === 429) {
        this.generalError = 'Demasiados intentos. Espera un momento e inténtalo de nuevo.'
      } else {
        this.generalError = 'No se pudo guardar. Revisa tu conexión e inténtalo de nuevo.'
      }
    },
    showSuccess() {
      this.successMessage =
        this.form.status === 'public' ? 'Noticia publicada correctamente.' : 'Cambios guardados correctamente.'
      clearTimeout(this.successTimeout)
      this.successTimeout = setTimeout(() => {
        this.successMessage = null
      }, 4000)
    },
  },
  computed: {
    urlPreview() {
      if (this.extra.ver_english) {
        return this.data.PathUrlEn
      }
      return this.data.PathUrlEs
    },
  },
}
</script>
